export default {
  // Navigation
  'nav.timer': 'ٹائمر',
  'nav.stopwatch': 'سٹاپ واچ',
  'nav.worldclock': 'عالمی گھڑی',
  'nav.timestamp': 'ٹائم سٹیمپ',
  'nav.home': 'گھر',

  // Common buttons and actions
  'button.start': 'شروع کریں',
  'button.pause': 'موقوف کریں',
  'button.stop': 'رکیں',
  'button.reset': 'دوبارہ سیٹ کریں',
  'button.ok': 'ٹھیک ہے',
  'button.cancel': 'منسوخ کریں',
  'button.close': 'بند کریں',
  'button.save': 'محفوظ کریں',
  'button.delete': 'حذف کریں',
  'button.edit': 'ترمیم کریں',
  'button.back': 'واپس',
  'button.next': 'اگلا',
  'button.previous': 'پچھلا',
  'button.submit': 'جمع کریں',
  'button.confirm': 'تصدیق کریں',
  'button.convert': 'تبدیل کریں',
  'button.copy': 'کاپی کریں',
  'button.copied': 'کاپی ہو گیا!',
  'button.now': 'ابھی',
  'button.clear': 'صاف کریں',

  // Common labels
  'label.hours': 'گھنٹے',
  'label.minutes': 'منٹ',
  'label.seconds': 'سیکنڈ',
  'label.milliseconds': 'ملی سیکنڈ',
  'label.minute': 'منٹ',
  'label.second': 'سیکنڈ',
  'label.sound': 'آواز',
  'label.soundAlert': 'آواز',
  'label.fullscreen': 'مکمل اسکرین',
  'label.language': 'زبان',
  'label.selectLanguage': 'زبان منتخب کریں',
  'label.languageSelectorInfo': 'فی الوقت {{count}} زبانوں کی معاونت کرتا ہے۔ اوپر دیے گئے اختیارات میں سے اپنی پسندیدہ زبان منتخب کریں۔',

  // Common messages
  'message.timerComplete': 'ٹائمر مکمل!',
  'message.timerCompleteDesc': 'آپ کا ٹائمر مکمل ہو گیا',
  'message.timerCompleteBody': 'آپ کا کاؤنٹ ڈاؤن ٹائمر مکمل ہو گیا!',
  'message.stopwatchStarted': 'سٹاپ واچ شروع ہو گیا',
  'message.stopwatchStartedDesc': 'سٹاپ واچ کی وقت گنتی شروع ہو گئی',
  'message.stopwatchStopped': 'سٹاپ واچ رک گیا',
  'message.stopwatchStoppedDesc': 'سٹاپ واچ کی وقت گنتی موقوف ہو گئی',
  'message.stopwatchReset': 'سٹاپ واچ دوبارہ سیٹ ہو گیا',
  'message.stopwatchResetDesc': 'سٹاپ واچ صفر پر دوبارہ سیٹ ہو گیا',
  'message.notificationPermission': 'ٹائمر ختم ہونے پر انتباہات حاصل کرنے کے لیے اطلاعات کی اجازت دیں',
  'message.clickToEdit': 'وقت کو براہ راست ترمیم کرنے کے لیے وقت کے نمبروں پر کلک کریں',
  'message.addHours': '+ گھنٹے شامل کریں',
  'message.escToExit': 'مکمل اسکرین سے باہر نکلنے کے لیے ESC دبائیں',
  'message.timeRemaining': '{{minutes}} منٹ {{seconds}} سیکنڈ باقی ہے',
  'message.minutesRemaining': '{{minutes}} منٹ باقی ہے',
  'message.secondsRemaining': '{{seconds}} سیکنڈ باقی ہے',
  'message.stopwatchTimeElapsed': '{{minutes}} منٹ {{seconds}} سیکنڈ گزر گئے',
  'message.stopwatchMinutesElapsed': '{{minutes}} منٹ گزر گئے',
  'message.stopwatchSecondsElapsed': '{{seconds}} سیکنڈ گزر گئے',
  'message.invalidTimestamp': 'غلط ٹائم سٹیمپ',
  'message.invalidDateTime': 'غلط تاریخ اور وقت',
  'message.conversionError': 'تبدیلی میں خرابی',

  // Time units
  'time.am': 'صبح',
  'time.pm': 'شام',
  'time.now': 'ابھی',
  'time.today': 'آج',
  'time.yesterday': 'کل',
  'time.tomorrow': 'کل',

  // Common errors
  'error.pageNotFound': 'صفحہ نہیں ملا',
  'error.somethingWrong': 'کچھ غلط ہو گیا',
  'error.tryAgain': 'براہ مہربانی بعد میں دوبارہ کوشش کریں',

  // Footer
  'footer.about': 'timer.today کے بارے میں',
  'footer.aboutDesc': 'timer.today ایک پروفیشنل آن لائن ٹائمنگ ٹول پلیٹ فارم ہے جو تین بنیادی خصوصیات فراہم کرتا ہے:',
  'footer.timerDesc': 'قابل تشکیل کاؤنٹ ڈاؤن ٹول جو منٹ اور گھنٹوں کی ترتیبات کی حمایت کرتا ہے، کام کے توجہ، کھانا پکانے کی وقت گنتی، تعلیم کے انتظام وغیرہ کے لیے بہترین۔ آواز کی انتباہات اور ڈیسک ٹاپ اطلاعات کی خصوصیات ہیں۔',
  'footer.stopwatchDesc': 'اعلیٰ درستگی والا ٹائمنگ ٹول جس میں ملی سیکنڈ کی درستگی ہے، کھیلوں کی تربیت، کھانا پکانے کی کارروائیوں، امتحان کی مشق اور دوسری صورتحال کے لیے موزوں ہے جہاں درست وقت گنتی درکار ہو۔',
  'footer.worldClockDesc': 'دنیا بھر کے اہم شہروں کے وقت کی حقیقی وقتی نمائش ذہین ٹائم زون کے حساب کے ساتھ، بین الاقوامی کاروباری رابطہ اور ٹائم زون کے پار تعاون کو آسان بناتا ہے۔',
  'footer.timestampDesc': 'Unix ٹائم سٹیمپ کنورٹر جو ٹائم سٹیمپ اور تاریخ وقت کے درمیان دونوں طرفہ تبدیلی کی حمایت کرتا ہے، سیکنڈ اور ملی سیکنڈ دونوں فارمیٹ کی حمایت کے ساتھ۔',
  'footer.termsOfService': 'خدمات کی شرائط',
  'footer.privacy': 'رازداری',
  'footer.contactUs': 'ہم سے رابطہ کریں',
  'footer.changeLanguage': 'زبان تبدیل کریں',
  'footer.moreLanguage': 'مزید زبانیں',
  'footer.copyright': '© timer.today 2024',

  // Quick actions
  'quick.add30s': '+30 سیکنڈ',
  'quick.add1min': '+1 منٹ',
  'quick.add5min': '+5 منٹ',
  'quick.add10min': '+10 منٹ',
  'quick.add30min': '+30 منٹ',

  // Breadcrumb
  'breadcrumb.minuteTimer': '{{minutes}} منٹ کا ٹائمر',
  'breadcrumb.timer': 'ٹائمر',
  'breadcrumb.stopwatch': 'سٹاپ واچ',
  'breadcrumb.worldClock': 'عالمی گھڑی',
  'breadcrumb.termsOfService': 'خدمات کی شرائط',
};